import styled, { css } from "styled-components";
import { Color } from "../../../../../../themes/definitions/casino777/casino777-colors";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import {JACKPOT_STATE} from '../../../../../../../common/const/jackpot_map_ids';

interface IJackpotWidgetClockLabelBox{
    forcePCView: boolean;
    state: JACKPOT_STATE;
    widgetIsMinimized?: boolean;
    widgetWidth: number;
}

const JackpotWidgetClockLabelDefaultBox = styled.div<IJackpotWidgetClockLabelBox>`
    width: ${({widgetIsMinimized}) => widgetIsMinimized ? "100%" : "74%" };
    text-align: ${({widgetIsMinimized}) => widgetIsMinimized ? "center" : "left" };
    ${({forcePCView}) => !forcePCView && css`
        @media ${({theme}) => theme.mediaQuery.sAndBelow} {
            text-align: center;
            width: 100%;
        }
    `}
    font-family: ${({theme}) => theme.font.family.body};
    text-transform: uppercase;
    color: ${({state, theme}) => state === JACKPOT_STATE.Hot ? theme.colors.brandPrimary : theme.colors.bodyText };
    letter-spacing: 0.02rem;
    font-size: ${({widgetWidth, widgetIsMinimized}) => {
        if (widgetIsMinimized) {
            /** In minimized view at a widget width of 375px, the amount should be of font-size 9px */
            return widgetWidth * 9 / 375 + "px";
        }
        /** In desktop view at a widget width of 468px, the amount should be of font-size 15px */
        return widgetWidth * 14 / 468 + "px";
    }};
    ${({forcePCView, widgetWidth, theme}) => !forcePCView ? css`
        @media ${theme.mediaQuery.sAndBelow} {
            /** In mobile view at a widget width of 131px, the amount should be of font-size 9px */
            font-size: ${widgetWidth * 9 / 131 + "px"};
        }
    ` : null}
`;

const JackpotWidgetClockLabelCasino777Box = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({state, theme}) => state === JACKPOT_STATE.Hot ? theme.colors.buttonWarning : Color.blackTeal };
`;
export const JackpotWidgetClockLabelBox = styledByTheme(JackpotWidgetClockLabelDefaultBox)
    .forCasino777(JackpotWidgetClockLabelCasino777Box).apply();
